import { render, staticRenderFns } from "./UpcomingCampaigns.vue?vue&type=template&id=7db7c455&scoped=true"
import script from "./UpcomingCampaigns.vue?vue&type=script&lang=ts"
export * from "./UpcomingCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./UpcomingCampaigns.vue?vue&type=style&index=0&id=7db7c455&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db7c455",
  null
  
)

export default component.exports